import { memo } from 'react';
import { IconButton, InputAdornment, MenuItem, Select, Stack, Typography } from '@mui/material';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';

import { IDirectionToSort, IKeyToSort, ISortOptionsProps } from '../../types';

export const SORT_OPTIONS = [
  { value: IKeyToSort.COUNT, label: 'Count' },
  { value: IKeyToSort.NUMBER, label: 'Number' },
  { value: IKeyToSort.ABC, label: 'ABC' },
  { value: IKeyToSort.DATE, label: 'Date' },
];
export const SortOptions = memo(({ handleChange, changeDirectionSort, typeSort }: ISortOptionsProps) => {
  return (
    <Stack direction='row' gap={1} p={1}>
      <Select
        fullWidth
        value={typeSort.keyToSort}
        inputProps={{ 'aria-label': 'Sort selection' }}
        onChange={handleChange}
        startAdornment={
          <InputAdornment position='start'>
            <Typography component='span'>Sort By:</Typography>
          </InputAdornment>
        }
      >
        {SORT_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      <IconButton onClick={changeDirectionSort} data-testid={`move-direction-${typeSort.direction}-button`}>
        {typeSort.direction === IDirectionToSort.ASC ? <ArrowUpward /> : <ArrowDownward />}
      </IconButton>
    </Stack>
  );
});
